import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

import { map } from "rxjs/operators";
import { UserForm } from "app/interfaces/user-form.interface";
import { ReportForm } from "app/interfaces/report-form.interface";

const reportsUrlApi = environment.reportsUrlApi;
const reportsWithFiltersUrlApi = environment.reportsWithFiltersUrlApi;
const reportsAuditUrlApi = environment.reportsAuditUrlApi;

@Injectable()
export class ReportService {
  public user: UserForm;

  constructor(private http: HttpClient) {}

  // get Audits Range Date
  getAuditLogs(from: string, to: string) {
    const body = { from, to };
    return this.http
      .request("POST", `${reportsAuditUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  // get Audits Range Date By User
  getAuditLogsByIdUser(id: number, from: string, to: string) {
    const body = { from, to };
    return this.http
      .request("POST", `${reportsAuditUrlApi}/` + id, { body })
      .pipe(map((resp: any) => resp));
  }

  // TODO
  getReports() {
    return this.http
      .request("GET", `${reportsUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getReportsWithFilter(filters) {
    const params = filters;
    return this.http
      .post(`${reportsWithFiltersUrlApi}`, params)
      .pipe(map((resp: any) => resp));
  }

  getReportById(id: number) {
    return this.http
      .request("GET", `${reportsUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  updateReportById(id: number, reportModel: ReportForm) {
    const body = reportModel;
    return this.http
      .request("PUT", `${reportsUrlApi}/` + id, { body })
      .pipe(map((resp: any) => resp));
  }

  createReport(reportModel: ReportForm) {
    const body = reportModel;
    return this.http
      .request("POST", `${reportsUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  deleteReportById(id: number) {
    return this.http
      .request("DELETE", `${reportsUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }
}
